export const populateShortcodes = (
  content: string,
  shortCodeValues: Record<string, string>,
) => {
  return content.replace(
    /(?<delimit_start>{{\s*?)(?<lookupKey>[\w|\.]+)(?<delimit_end>\s*?}})/g,
    (
      fullMatch,
      ...matches: (string | number | Record<'lookupKey', string>)[]
    ) => {
      // last arg is always group lookup
      const groups = matches[matches.length - 1] as Record<'lookupKey', string>;
      const lookedUp = shortCodeValues[groups.lookupKey];
      return lookedUp || fullMatch;
    },
  );
};
